import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import { SERVER_URL } from "../../api/url";
import { Link, useNavigate } from "react-router-dom";

const ProfileForm = () => {
  const [formReady, setFormReady] = useState(false);
  const [user, setUser] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
 const [error,setError]=useState("")
   const [message,setMessage]=useState("")
   const [Loading,setLoading]=useState(false)
const [data,setData]=useState([])
    const fetchData = async () => {
    setLoading(true);
  const id=localStorage.getItem("userId")
    try {
      const response = await axios.get(`${SERVER_URL}/auth/payment/${id}`);
      const fetchedData = response.data?.data || [];
      setData(fetchedData);
    } catch (err) {
      console.error(err);
     
    } finally {
      setLoading(false);
    }
  };

  

  useEffect(() => {
    const userName = localStorage.getItem("userName") || "";
    const userEmail = localStorage.getItem("userEmail") || "";
    const userPhoneNumber = localStorage.getItem("userPhoneNumber") || "";

    setUser(userName);
    setEmail(userEmail);
    setPhone(userPhoneNumber);
    setFormReady(true);
       fetchData()
  }, []);

  const validationSchema = yup.object({
    name: yup.string().required("Name is required"),
    email: yup
      .string()
      .email("Invalid Email Format")
      .test("complete-domain", "Invalid Email Address", (value) => /@.+\..+/.test(value))
      .required("Email is required"),
    phoneNumber: yup
      .number()
      .typeError("Phone Number must be a number")
      .required("Phone Number is required"),
  });

  const passwordSchema = yup.object({
    oldPassword: yup.string().required("Old password is required"),
    newPassword: yup.string().min(6, "At least 6 characters").required("New password is required"),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("newPassword"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  if (!formReady) return <p>Loading profile...</p>;

  const initialValues = {
    name: user,
    email: email,
    phoneNumber: phone,
  };

  return (
    <>
      <Toaster position="bottom-right" reverseOrder={false} />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          toast.success("Submitted successfully");
          console.log(values);
        }}
        validateOnBlur={false}
        validateOnChange={false}
      >
        {({ isSubmitting }) => (
          <div className="react-blog-form">
            <h2 className="contact-title">Profile</h2>
            <div id="blog-form" className="blog-form">
              <Form id="contact-form">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="back-input">
                      <Field name="name" type="text" placeholder="Enter Your Name" readOnly />
                      <ErrorMessage className="errorComp" name="name" component="div" />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="back-input">
                      <Field name="email" type="email" placeholder="Enter Your Email" readOnly />
                      <ErrorMessage className="errorComp" name="email" component="div" />
                    </div>
                  </div>
                  
       
                  <div className="col-lg-12">
                    <div className="back-input">
                      <Field name="phoneNumber" type="text" placeholder="Enter Your Phone Number" readOnly />
                      <ErrorMessage className="errorComp" name="phoneNumber" component="div" />
                    </div>
                  </div>
                       <div style={{display:"flex",justifyContent:"end",alignItems:"center"}}>
                                     <h4 className="login-title">
                             <Link to="#" >
                               <div
                                      
                                        onClick={() => setShowPaymentModal(true)}
                                        className=""
                                      >
                                        Enrolled Course
                                      </div>
                             </Link>
                              
                              </h4>
                          
                            </div>
                             {message && (
          <div className="alert alert-info">
            {message}
           
          </div>
        )}
                  <div className="col-lg-12 d-flex justify-content-start mt-3">
                    <button
                      type="button"
                      onClick={() => setShowPasswordModal(true)}
                      className="btn btn-primary"
                    >
                      Change Password
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        )}
      </Formik>

      {showPasswordModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Change Password</h3>
            <Formik
              initialValues={{
                oldPassword: "",
                newPassword: "",
                confirmPassword: "",
              }}
              validationSchema={passwordSchema}
              onSubmit={async (values, { resetForm }) => {
                try {
                     const response = await axios.post(`${SERVER_URL}/auth/change-password`, {
                      email,
                      old_password:values.oldPassword,
                      confirm_password:values.confirmPassword,
                      password:values.newPassword
                     }, {
        headers: { "Content-Type": "application/json" },
      });
                  setMessage("Password updated successfully");
                  setShowPasswordModal(false);
                  setError("")
                  resetForm();
                } catch (err) {
                  setError(err.response?.data?.error);
                }
              }}
            >
              <Form>
                <div className="form-group ">
                  <Field name="oldPassword" type="password" placeholder="Old Password" className="form-control rounded-input" />
                  <ErrorMessage name="oldPassword" component="div" className="errorComp " />
                </div>
                <div className="form-group">
                  <Field name="newPassword" type="password" placeholder="New Password" className="form-control rounded-input" />
                  <ErrorMessage name="newPassword" component="div" className="errorComp" />
                </div>
                <div className="form-group">
                  <Field name="confirmPassword" type="password" placeholder="Confirm Password" className="form-control rounded-input"/>
                  <ErrorMessage name="confirmPassword" component="div" className="errorComp" />
                </div>

        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}
                <div className="d-flex justify-content-end gap-2 mt-3">
                  <button type="button" className="btn btn-gray" onClick={() => setShowPasswordModal(false)}>
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save
                  </button>
                </div>
              </Form>
            </Formik>
          </div>
        </div>
      )}
      {showPaymentModal && (
  <div className="modal-overlay">
    <div className="modal-content">
      <h3>Enrolled Courses</h3>

      {data?.length === 0 ? (
        <p>No courses enrolled.</p>
      ) : (
        <ul>
          {data?.map((payment) => (
            <li key={payment._id} style={{ marginBottom: "10px",display:"flex" ,justifyContent:"start"}}>
              <strong>{payment.course?.name}</strong>  - 
              <span style={{ marginLeft: "5px", color: payment.status ? "green" : "orange" }}>
                {payment.status ? "Accepted" : "Pending"}
              </span>
            </li>
          ))}
        </ul>
      )}

      <div className="d-flex justify-content-end mt-3">
        <button onClick={() => setShowPaymentModal(false)} className="btn btn-gray">
          Close
        </button>
      </div>
    </div>
  </div>
)}


      <style>
        {`
          .modal-overlay {
            position: fixed;
            top: 0; left: 0;
            width: 100%; height: 100%;
            background: rgba(0,0,0,0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
          }
          .modal-content {
            background: white;
            padding: 30px;
            border-radius: 8px;
            width: 100%;
            max-width: 400px;
          }
          .form-group {
            margin-bottom: 15px;
          }
            .rounded-input {
  border-radius: 8px;
}
          .form-group input {
            width: 100%;
            padding: 10px;
          }
          .errorComp {
            color: red;
            font-size: 12px;
          }
            .form-group input:focus {
  border-color: #007bff !important;
 
  outline: none;
}

        `}
      </style>
    </>
  );
};

export default ProfileForm;
